import React from "react";

import { MenuItemFormFragment } from "../../../types";
import DialogContent from "../../MenuItem/Dialog/Content";
import { MenuItemState } from "../../MenuItem/reducer";
import { emptyAllergenFormState } from "../../Recipe/Form/allergens";
import { MenuItemAppearanceState } from "../reducer";
import { getMenuItemAppearanceStateText, onConvertMenuItemAppearance, onEditMenuItemAppearance } from "../utils";

interface MenuItemAppearanceEditDialogFullProps {
  open: boolean;
  onClose: () => void;
  menuItemAppearance: MenuItemAppearanceState;
  menuItem: MenuItemFormFragment;
  onEdit: onEditMenuItemAppearance;
  onConvert: onConvertMenuItemAppearance;
}

const MenuItemAppearanceEditDialogFull = ({
  open,
  onClose,
  onEdit,
  onConvert,
  menuItemAppearance,
  menuItem,
}: MenuItemAppearanceEditDialogFullProps) => {
  const handleSave = (state: MenuItemState) => {
    const { menuItem, maxAmount, availableForOrder, allowSpecialRequests } = state;

    if (menuItemAppearance.type === "Edit" || menuItemAppearance.type === "Create") {
      onEdit({ menuItem, maxAmount, availableForOrder, allowSpecialRequests, initialMenuItem: menuItem });
    } else {
      onConvert({
        menuItem,
        maxAmount,
        availableForOrder,
        allowSpecialRequests,
        isOneOff: state.menuItem.isOneOff,
        initialMenuItem: menuItem,
      });
    }
    onClose();
  };

  return (
    <DialogContent
      open={open}
      onClose={onClose}
      onSave={handleSave}
      title={getMenuItemAppearanceStateText(menuItemAppearance)}
      variant="MenuItemAppearance"
      initState={{
        menuItem,
        maxAmount: menuItemAppearance.maxAmount,
        availableForOrder: menuItemAppearance.availableForOrder,
        allowSpecialRequests: menuItemAppearance.allowSpecialRequests,
        edited: false,
        ...emptyAllergenFormState(),
      }}
    />
  );
};

export default MenuItemAppearanceEditDialogFull;
